import React, { useEffect, useState } from "react";

const Hint = (props) => {
  const [isFirstVisit, setIsFirstVisit] = useState(false);

  useEffect(() => {
    const hasVisitedBefore = localStorage.getItem("firstTime");
    if (!hasVisitedBefore || hasVisitedBefore === "true") {
      setIsFirstVisit(true);
      setTimeout(() => {
        setIsFirstVisit(false);
      }, 5000);
    }
    if (window.innerWidth <= 768) {
      setIsFirstVisit(false);
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code === "Space") {
        props.function(); //have to call it directly because inside a useEffect :(
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return isFirstVisit === true &&
    (props.condition === undefined || props.condition === true) ? (
    <>
      <div className="!text-tiny rounded-medium p-4 border-2 border-white border-opacity-30 flex flex-col items-center gap-4 bg-gray-dark bg-opacity-30 w-2/5 relative">
        <button
          className="absolute top-0 right-0 rounded-full bg-gray-dark text-white px-1 m-1 hover:bg-gray-light hover:text-gray-dark transition-all bg-opacity-50"
          onClick={() => setIsFirstVisit(false)}
        >
          x
        </button>
        <p className="text-white text-center">{props.text}</p>
        <img src={props.icon} alt="key" className="animate-pulse"></img>
      </div>
    </>
  ) : null;
};

export default Hint;
